import {
  ITransactionFlagTypes,
  ITransactionType,
} from '~/@api/generated-api-types-account/Api'

type TransactionLabelProps = {
  typeId: ITransactionType
  flag?: ITransactionFlagTypes
}

const transactionsTypeLabels = {
  credit: 'Kredit',
  reservation: 'Rezervácia',
  investment: 'Investícia',
  revenue: 'Príjem',
  payoutRevenue: 'Príjem výnosu',
  payoutRevenue2: 'Príjem výnosu v predĺžení',
  revenueForHold: 'Výnos za obdobie držby',
  payoutBonus: 'Príjem bonusu',
  payoutBonusFixed: 'Príjem kap. rastu',
  payoutPrincipal: 'Príjem istiny',
  payoutReturnedPrincipal: 'Vrátená istina',
  payoutBonusWelcome: 'Príjem welcome bonusu',
  payoutVipBonus: 'Príjem VIP bonusu',
  investmentRevenueFee: 'Úhrada poplatku',
  withdrawal: 'Výber',
  bonusPrereservation: 'Predrezervačný bonus',
  bonusLastminute: 'Lastminute bonus',
  bonusPrincipal: 'Bonus z istiny',
  bonusAffiliate: 'Affiliate bonus',
  bonusWelcome: 'Welcome bonus',
  withdrawalPrincipal: 'Výber istiny',
  investments: 'Investícia',
  loanGranting: 'Poskytnutie pôžičky',
  loanPayment: 'Splátka pôžičky',
  giftPayment: 'Výplata darčeka',
  returnReserved: 'Rezervácia zrušená',
  all: 'Všetky transakcie',
  marketplaceBought: 'Kúpa investície',
  marketplaceSold: 'Predaj investície',
  marketplaceReservation: 'Rezervácia marketplace',
  marketplaceFee: 'Poplatok marketplace',
  gift: 'Darček',
  investmentTransferOut: 'Postúpenie investície - odovzdanie',
  investmentTransferIn: 'Postúpenie investície - prevzatie',
  dispoLegacyIn: 'Pripísanie disponibilných prostriedkov z pôvodného systému',
  dispoLegacyOut: 'Odpis disponibilných prostriedkov z pôvodného systému',
}

function getTransactionType({ typeId, flag }: TransactionLabelProps) {
  if (flag === ITransactionFlagTypes.CanceledReturnInvestmentEarly) {
    if (typeId === ITransactionType.PayoutRevenue) return 'revenueForHold'
    if (typeId === ITransactionType.PayoutPrincipal)
      return 'payoutReturnedPrincipal'
  }

  return typeId
}

function getTransactionTypeLabel({ typeId, flag }: TransactionLabelProps) {
  const transactionType = getTransactionType({ typeId, flag })
  return transactionsTypeLabels[
    transactionType as keyof typeof transactionsTypeLabels
  ]
}

export { type TransactionLabelProps, getTransactionTypeLabel }
